export default __webpack_public_path__ + "comprehensive_md1179d.png";